var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _rect8, _rect9, _rect10, _rect11, _rect12, _circle2, _rect13, _rect14, _rect15, _rect16, _circle3, _rect17, _rect18, _rect19, _rect20, _circle4, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _text, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _text2, _rect42, _text3, _rect43, _text4, _text5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagementInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 540",
    fill: "none",
    role: "img",
    "aria-label": "Unified social media engagement inbox dashboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smaInboxBg",
    x1: 0,
    y1: 0,
    x2: 880,
    y2: 540,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0a1628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002454"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smaInboxAccent",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a00a8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 540,
    rx: 16,
    fill: "url(#smaInboxBg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 280,
    height: 492,
    rx: 12,
    fill: "#fff",
    fillOpacity: 0.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 140,
    height: 12,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.85
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 64,
    width: 100,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 88,
    width: 240,
    height: 36,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.06
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 100,
    width: 80,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 136,
    width: 240,
    height: 72,
    rx: 10,
    fill: "url(#smaInboxAccent)",
    fillOpacity: 0.18,
    stroke: "#9e00ff",
    strokeOpacity: 0.35
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 172,
    r: 12,
    fill: "#E1306C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 156,
    width: 120,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.85
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 172,
    width: 180,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.45
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 186,
    width: 140,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.28
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 152,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#9e00ff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 220,
    width: 240,
    height: 72,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 256,
    r: 12,
    fill: "#1877F2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 240,
    width: 130,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.85
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 256,
    width: 170,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.45
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 270,
    width: 120,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.28
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 304,
    width: 240,
    height: 72,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 340,
    r: 12,
    fill: "#0A66C2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 324,
    width: 140,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.85
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 340,
    width: 160,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.45
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 354,
    width: 130,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.28
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 388,
    width: 240,
    height: 72,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.05
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 424,
    r: 12,
    fill: "#000"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 408,
    width: 110,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.85
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 424,
    width: 150,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.45
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 438,
    width: 100,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.28
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 24,
    width: 536,
    height: 492,
    rx: 12,
    fill: "#fff",
    fillOpacity: 0.04
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 44,
    width: 180,
    height: 12,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.85
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 64,
    width: 120,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.3
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 44,
    width: 116,
    height: 28,
    rx: 8,
    fill: "#25D366",
    fillOpacity: 0.25
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 742,
    y: 63,
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    fill: "#9dffc0"
  }, "3 new")), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 96,
    width: 496,
    height: 280,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.03
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 116,
    width: 220,
    height: 10,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.75
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 136,
    width: 400,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.25
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 160,
    width: 320,
    height: 56,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.06
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 176,
    width: 240,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.7
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 192,
    width: 280,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.35
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 228,
    width: 280,
    height: 56,
    rx: 10,
    fill: "url(#smaInboxAccent)",
    fillOpacity: 0.15
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 244,
    width: 200,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.8
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 260,
    width: 240,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.4
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 296,
    width: 320,
    height: 56,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.06
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 312,
    width: 260,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.7
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 328,
    width: 220,
    height: 6,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.35
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 392,
    width: 496,
    height: 104,
    rx: 10,
    fill: "#fff",
    fillOpacity: 0.05
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 412,
    width: 360,
    height: 48,
    rx: 8,
    fill: "#fff",
    fillOpacity: 0.06
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 376,
    y: 442,
    fontFamily: "system-ui,sans-serif",
    fontSize: 12,
    fill: "#fff",
    fillOpacity: 0.4
  }, "Write a reply...")), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 736,
    y: 456,
    width: 80,
    height: 28,
    rx: 8,
    fill: "url(#smaInboxAccent)",
    fillOpacity: 0.75
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 758,
    y: 475,
    fontFamily: "system-ui,sans-serif",
    fontSize: 11,
    fill: "#fff"
  }, "Send")), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 468,
    width: 120,
    height: 8,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 508,
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    fill: "#fff",
    fillOpacity: 0.45
  }, "Avg. response time: 12 min")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 508,
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    fill: "#fff",
    fillOpacity: 0.45
  }, "Resolution rate: 94%")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementInbox);
export default __webpack_public_path__ + "static/media/engagement-inbox.04536b88b167bada8adee1346c2576d0.svg";
export { ForwardRef as ReactComponent };